module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width"
  }, [_c('top-nav', {
    attrs: {
      "isWhite": false,
      "hasLogo": true,
      "lang": _vm.$route.params.lang
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "flex flex-column"
  }, [_c('article', {
    staticClass: "flex flex-wrap justify-between"
  }, [_c('header', {
    staticClass: "px3 py4 col-12"
  }, [_c('div', {
    staticClass: "lg-col-9"
  }, [(_vm.content.title) ? _c('h1', {
    staticClass: "m0",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.lede) ? _c('p', {
    staticClass: "m0 h3 mt3",
    domProps: {
      "innerHTML": _vm._s(_vm.content.lede)
    }
  }) : _vm._e(), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.windowLocation,
      "title": _vm.content.title,
      "description": _vm.convertHTMLToText(_vm.content.lede),
      "hashtags": "stop_e40"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "mt2"
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-twitter social-btn on-light"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-facebook social-btn on-light"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-vk social-btn on-light",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-linkedin social-btn on-light"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]), _vm._v(" "), _c('aside', {
    staticClass: "lg-col-2 md-col-3 sm-col-12 xs-col-12 mt4 pl3"
  }, [(_vm.articleHeaders.length > 1) ? _c('nav', {
    staticClass: "sticky",
    attrs: {
      "id": "toc"
    }
  }, [_c('ul', {
    staticClass: "list-reset m0"
  }, _vm._l((_vm.articleHeaders), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "mb2"
    }, [_c('a', {
      staticClass: "dark-grey",
      class: {
        'active': false
      },
      attrs: {
        "href": item.href
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      },
      on: {
        "click": function($event) {
          return _vm.scrollTo($event, item.id)
        }
      }
    })])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lg-col-7 md-col-9 sm-col-12 xs-col-12 mb4 default-links-nodeco"
  }, [_c('section', {
    staticClass: "px3 my4 body",
    attrs: {
      "id": "article-body"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.body)
    }
  })]), _vm._v(" "), _c('aside', {
    staticClass: "lg-col-3 md-col-12 sm-col-12 xs-col-12 mt4 px3"
  }, [_c('action-nav', {
    staticClass: "sticky"
  })], 1)])]), _vm._v(" "), _c('footer-bar', {
    attrs: {
      "lang": _vm.$route.params.lang
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11fb178a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 119
// module chunks = 0